import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { inputParentContainer } from '@/components/design-system/shared-styles';
import { CountryData } from './types';

export interface PhoneInputFieldProps {
  value: string;
  onChange: (value: string, data: CountryData, event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  error?: string;
  label?: string;
  placeholder?: string;
  defaultCountry?: string;
  className?: string;
  inputClassName?: string;
  disabled?: boolean;
}

export const PhoneInputField: React.FC<PhoneInputFieldProps> = ({
  value,
  onChange,
  onBlur,
  error,
  label,
  placeholder = '1234-567',
  defaultCountry = 'be',
  className = '',
  inputClassName = '',
  disabled = false,
}) => {
  return (
    <div className={`${inputParentContainer} ${className}`}>
      {label && <label className="mb-1 block text-[12px] font-medium text-N900">{label}</label>}
      <PhoneInput
        country={defaultCountry}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        inputClass={`w-full rounded-sm h-6 border ${
          error ? 'border-red-500' : 'border-E30'
        } bg-E30 py-2 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500 ${inputClassName}`}
        buttonClass="border bg-E30 border-E30 rounded-l-md"
        containerClass="phone-input-container"
        dropdownClass="country-dropdown"
        placeholder={placeholder}
      />
      {error && <p className="text-red-500 mt-1 text-xs">{error}</p>}
    </div>
  );
};
